var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-xs-12 emergo-contact-pd",
            class: !_vm.emergoContactBanner ? "emergo-contact-removed" : "",
          },
          [
            _c("div", { staticClass: "emergo-contact ptb-10" }, [
              _c("div", { staticClass: "row m-0" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("p", { staticClass: "country-representation" }, [
                    _vm._v(
                      " Are you an Emergo by UL in-country representation client? "
                    ),
                  ]),
                  _c("img", {
                    staticClass: "close-icon",
                    attrs: {
                      src: "/static/images/icons/close_blue_icon.svg",
                      alt: "close-icon",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.dismissTab()
                      },
                    },
                  }),
                ]),
                _vm._m(0),
                _c("div", { staticClass: "row col-xs-12 contact-emergo" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "https://www.emergobyul.com/contact" },
                      on: { click: _vm.clearData },
                    },
                    [_vm._v("Contact Emergo")]
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
      _c("div", { staticClass: "col-md-12 crumb-selection" }, [
        _c(
          "ul",
          { staticClass: "crumb-trail" },
          _vm._l(_vm.slidesInfo, function (slide, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "col-sm-4 p-0",
                class: {
                  "is-active-slide col-xs-8": _vm.currentSlider === index,
                  "col-xs-2": _vm.currentSlider !== index,
                  completed_slide: _vm.currentSlider > index,
                },
              },
              [
                _c("div", { staticClass: "crumb" }, [
                  _c("img", {
                    staticClass: "breadcrumb-img",
                    attrs: {
                      src: "/static/images/icons/circle_check.svg",
                      alt: "check-icon",
                    },
                  }),
                  _c("span", [_vm._v(_vm._s(slide.title))]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "col-xs-12 p-0" }, [
        _c(
          "form",
          {
            staticClass: "row m-0",
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
          },
          [
            _vm.currentSlider == 0
              ? [
                  _vm._m(1),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-md-6 col-sm-6 pl-0 xs-p-0" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 account-details" },
                        [
                          _c("div", { staticClass: "info" }, [
                            _vm._v("Provide account details below:"),
                          ]),
                          _c(
                            "el-popover",
                            {
                              staticClass: "info-icon-class",
                              attrs: {
                                "popper-append-to-body": "false",
                                placement: "bottom-end",
                                trigger: "click",
                                "popper-class":
                                  "popup-background tootip-custom-small-width-class",
                              },
                              on: {
                                show: function ($event) {
                                  _vm.emailInfoActive = true
                                },
                                hide: function ($event) {
                                  _vm.emailInfoActive = false
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "content" }, [
                                _c("ul", { staticClass: "word-break" }, [
                                  _c("li", [
                                    _c("span", [
                                      _vm._v(
                                        "Please fill the mandatory details (if any) for all steps and they will be available with “"
                                      ),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "mandatory-sign" },
                                      [_vm._v("*")]
                                    ),
                                    _c("span", [_vm._v("” symbol.")]),
                                  ]),
                                  _c("li", [
                                    _vm._v(
                                      " A unique email address is required and can be used to access a single RAMS account. If your organization has an existing account, you will be restricted from joining as long as your email address is associated with another active account. Contact your organization to be added as a team member. "
                                    ),
                                  ]),
                                  _c("li", [
                                    _vm._v(
                                      " To reduce fraudulent account creation, public domain email addresses have been restricted. "
                                    ),
                                  ]),
                                ]),
                              ]),
                              !_vm.emailInfoActive
                                ? _c("img", {
                                    staticClass: "info-img",
                                    attrs: {
                                      slot: "reference",
                                      src: "/static/images/icons/info_icon.svg",
                                      alt: "info-icon",
                                    },
                                    slot: "reference",
                                  })
                                : _vm._e(),
                              _vm.emailInfoActive
                                ? _c("img", {
                                    staticClass: "info-img",
                                    attrs: {
                                      slot: "reference",
                                      src: "/static/images/icons/info_icon_active.svg",
                                      alt: "infoactive-icon",
                                    },
                                    slot: "reference",
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12 col-md-6" },
                        [
                          _c("label", { attrs: { for: "first-name" } }, [
                            _vm._v("First Name"),
                          ]),
                          _c("span", { staticClass: "required_astric" }, [
                            _vm._v("*"),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.user_data.first_name,
                                expression: "user_data.first_name",
                                modifiers: { trim: true },
                              },
                            ],
                            staticClass: "form-control",
                            class: _vm.$v.user_data.first_name.$error
                              ? "invalid-border"
                              : "",
                            attrs: {
                              id: "first-name",
                              type: "text",
                              placeholder: "First Name",
                              maxlength: "35",
                            },
                            domProps: { value: _vm.user_data.first_name },
                            on: {
                              blur: [
                                function ($event) {
                                  return _vm.$v.user_data.first_name.$touch()
                                },
                                function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              ],
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.user_data,
                                  "first_name",
                                  $event.target.value.trim()
                                )
                              },
                            },
                          }),
                          _vm.$v.user_data.first_name.$error
                            ? _c("div", [
                                !_vm.$v.user_data.first_name.required
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [_vm._v(" Complete required field ")]
                                    )
                                  : !_vm.$v.user_data.first_name.minLength
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [
                                        _vm._v(
                                          " Minimum 2 characters required. "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12 col-md-6" },
                        [
                          _c("label", { attrs: { for: "last-name" } }, [
                            _vm._v("Last Name"),
                          ]),
                          _c("span", { staticClass: "required_astric" }, [
                            _vm._v("*"),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.user_data.last_name,
                                expression: "user_data.last_name",
                                modifiers: { trim: true },
                              },
                            ],
                            staticClass: "form-control",
                            class: _vm.$v.user_data.last_name.$error
                              ? "invalid-border"
                              : "",
                            attrs: {
                              id: "last-name",
                              type: "text",
                              placeholder: "Last Name",
                              maxlength: "35",
                            },
                            domProps: { value: _vm.user_data.last_name },
                            on: {
                              blur: [
                                function ($event) {
                                  return _vm.$v.user_data.last_name.$touch()
                                },
                                function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              ],
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.user_data,
                                  "last_name",
                                  $event.target.value.trim()
                                )
                              },
                            },
                          }),
                          _vm.$v.user_data.last_name.$error
                            ? _c("div", [
                                !_vm.$v.user_data.last_name.required
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [_vm._v(" Complete required field ")]
                                    )
                                  : !_vm.$v.user_data.last_name.minLength
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [
                                        _vm._v(
                                          " Minimum 2 characters required. "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c("div", { staticClass: "col-xs-12 p-0" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 col-xs-12 form-group form-email",
                          },
                          [
                            _c("label", { attrs: { for: "email-id" } }, [
                              _vm._v("Email"),
                            ]),
                            _c("span", { staticClass: "required_astric" }, [
                              _vm._v("*"),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.user_data.email,
                                  expression: "user_data.email",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              class: {
                                "invalid-border":
                                  _vm.$v.user_data.email.$error ||
                                  _vm.isFreeDomain,
                              },
                              attrs: {
                                id: "email-id",
                                type: "text",
                                placeholder: "Email",
                                maxlength: "65",
                              },
                              domProps: { value: _vm.user_data.email },
                              on: {
                                blur: [
                                  function ($event) {
                                    return _vm.checkEmailIsValid()
                                  },
                                  function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                ],
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.user_data,
                                    "email",
                                    $event.target.value.trim()
                                  )
                                },
                              },
                            }),
                            _vm.$v.user_data.email.$error
                              ? _c("div", [
                                  !_vm.$v.user_data.email.required
                                    ? _c(
                                        "div",
                                        { staticClass: "custom-error-class" },
                                        [_vm._v(" Complete required field ")]
                                      )
                                    : !_vm.$v.user_data.email.isValidMail
                                    ? _c(
                                        "div",
                                        { staticClass: "custom-error-class" },
                                        [_vm._v(" Invalid email format. ")]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm.isFreeDomain
                              ? _c(
                                  "div",
                                  { staticClass: "custom-error-class" },
                                  [
                                    _vm._v(
                                      " To combat fraudulent account creation, we have restricted certain domain email addresses from creating new accounts. "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "title" } }, [
                              _vm._v("Title"),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.user_data.title,
                                  expression: "user_data.title",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              class: _vm.$v.user_data.title.$error
                                ? "invalid-border"
                                : "",
                              attrs: {
                                id: "title",
                                type: "text",
                                placeholder: "Title",
                                maxlength: "50",
                              },
                              domProps: { value: _vm.user_data.title },
                              on: {
                                blur: [
                                  function ($event) {
                                    return _vm.$v.user_data.title.$touch()
                                  },
                                  function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                ],
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.user_data,
                                    "title",
                                    $event.target.value.trim()
                                  )
                                },
                              },
                            }),
                            !_vm.$v.user_data.title.isAllowedCharacters &&
                            _vm.$v.user_data.title.$error
                              ? _c(
                                  "div",
                                  { staticClass: "custom-error-class" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.specialCharacterErrMsg) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 form-group" },
                        [
                          _c("label", [_vm._v("Area of Responsibility")]),
                          _c("multiselect", {
                            staticClass: "multiselect-single-dropdown",
                            class: !_vm.user_data.area_responsible_id
                              ? "un-selected"
                              : "",
                            attrs: {
                              "show-labels": false,
                              "allow-empty": false,
                              searchable: false,
                              placeholder: "Area of Responsibility",
                              options: _vm.responsibilitiesList.map(
                                (type) => type.id
                              ),
                              "custom-label": (opt) =>
                                _vm.responsibilitiesList.find(
                                  (x) => x.id === opt
                                ).responsibility_name,
                            },
                            model: {
                              value: _vm.user_data.area_responsible_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.user_data,
                                  "area_responsible_id",
                                  $$v
                                )
                              },
                              expression: "user_data.area_responsible_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              : _vm.currentSlider == 1
              ? [
                  _vm._m(2),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-md-6 col-sm-6 pl-0 xs-p-0" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 account-details pb-10" },
                        [
                          _c("div", { staticClass: "info" }, [
                            _vm._v(
                              "Provide Company and address details below:"
                            ),
                          ]),
                          _c(
                            "el-popover",
                            {
                              staticClass: "info-icon-class",
                              attrs: {
                                placement: "bottom-end",
                                trigger: "click",
                                "popper-class":
                                  "popup-background tootip-custom-small-width-class",
                              },
                              on: {
                                show: function ($event) {
                                  _vm.companyInfoActive = true
                                },
                                hide: function ($event) {
                                  _vm.companyInfoActive = false
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "content" }, [
                                _c("ul", { staticClass: "word-break" }, [
                                  _c("li", [
                                    _c("span", [
                                      _vm._v(
                                        "Please fill the mandatory details (if any) for all steps and they will be available with “"
                                      ),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "mandatory-sign" },
                                      [_vm._v("*")]
                                    ),
                                    _c("span", [_vm._v("” symbol.")]),
                                  ]),
                                  _c("li", [
                                    _vm._v(
                                      " An organization can create multiple RAMS accounts using the same name; however, duplicate account creation is not encouraged. Organization members can be added to the same account and access shared premium services. "
                                    ),
                                  ]),
                                ]),
                              ]),
                              !_vm.companyInfoActive
                                ? _c("img", {
                                    staticClass: "info-img ipad-right",
                                    attrs: {
                                      slot: "reference",
                                      src: "/static/images/icons/info_icon.svg",
                                      alt: "info-icon",
                                    },
                                    slot: "reference",
                                  })
                                : _vm._e(),
                              _vm.companyInfoActive
                                ? _c("img", {
                                    staticClass: "info-img",
                                    attrs: {
                                      slot: "reference",
                                      src: "/static/images/icons/info_icon_active.svg",
                                      alt: "infoactive-icon",
                                    },
                                    slot: "reference",
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._m(3),
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12 col-md-6" },
                        [
                          _c("label", { attrs: { for: "company_name" } }, [
                            _vm._v("Company Name"),
                          ]),
                          _c("span", { staticClass: "required_astric" }, [
                            _vm._v("*"),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.user_data.company,
                                expression: "user_data.company",
                                modifiers: { trim: true },
                              },
                            ],
                            staticClass: "form-control",
                            class: [
                              _vm.$v.user_data.company.$error
                                ? "invalid-border"
                                : "",
                            ],
                            attrs: {
                              id: "company_name",
                              type: "text",
                              placeholder: "Legal Company Name",
                              maxlength: "50",
                            },
                            domProps: { value: _vm.user_data.company },
                            on: {
                              blur: [
                                function ($event) {
                                  _vm.$v.user_data.company.$touch()
                                  _vm.checkCompanyName()
                                },
                                function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              ],
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.user_data,
                                    "company",
                                    $event.target.value.trim()
                                  )
                                },
                                function ($event) {
                                  _vm.companyExists = false
                                },
                              ],
                            },
                          }),
                          _vm.$v.user_data.company.$error
                            ? _c("div", [
                                !_vm.$v.user_data.company.required
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [_vm._v(" Complete required field ")]
                                    )
                                  : !_vm.$v.user_data.company.minLength
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [
                                        _vm._v(
                                          " Minimum 2 characters required. "
                                        ),
                                      ]
                                    )
                                  : !_vm.$v.user_data.company.isAlphaNum
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [
                                        _vm._v(
                                          " First character should be alphanumeric "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm.companyExists
                            ? _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "custom-warning-class" },
                                  [
                                    _vm._v(
                                      "Your company already exists in our system."
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12 col-md-6" },
                        [
                          _c("label", { attrs: { for: "country" } }, [
                            _vm._v("Country"),
                          ]),
                          _c("span", { staticClass: "required_astric" }, [
                            _vm._v("*"),
                          ]),
                          _c("multiselect", {
                            staticClass: "multiselect-single-dropdown",
                            class: {
                              "invalid-border": _vm.$v.user_data.country.$error,
                              "un-selected": !_vm.user_data.country,
                            },
                            attrs: {
                              id: "country",
                              placeholder: "Select a country",
                              label: "country_name",
                              "show-labels": false,
                              options: _vm.countriesList.map(
                                (type) => type.alpha_three_code
                              ),
                              "custom-label": (opt) =>
                                _vm.countriesList.find(
                                  (x) => x.alpha_three_code === opt
                                ).country_name,
                            },
                            model: {
                              value: _vm.user_data.country,
                              callback: function ($$v) {
                                _vm.$set(_vm.user_data, "country", $$v)
                              },
                              expression: "user_data.country",
                            },
                          }),
                          !_vm.$v.user_data.country.required &&
                          _vm.$v.user_data.country.$error
                            ? _c("div", { staticClass: "custom-error-class" }, [
                                _vm._v(" Complete required field "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12 col-md-6" },
                        [
                          _c("label", { attrs: { for: "street_address" } }, [
                            _vm._v("Street Address"),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.user_data.card_address,
                                expression: "user_data.card_address",
                              },
                            ],
                            staticClass: "form-control",
                            class: _vm.$v.user_data.card_address.$error
                              ? "invalid-border"
                              : "",
                            attrs: {
                              id: "street_address",
                              type: "text",
                              size: "60",
                              placeholder: "Street Address",
                            },
                            domProps: { value: _vm.user_data.card_address },
                            on: {
                              blur: function ($event) {
                                return _vm.$v.user_data.card_address.$touch()
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.user_data,
                                  "card_address",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          !_vm.$v.user_data.card_address.isAllowedCharacters &&
                          _vm.$v.user_data.card_address.$error
                            ? _c("div", { staticClass: "custom-error-class" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.specialCharacterErrMsg) + " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12 col-md-6" },
                        [
                          _c("label", { attrs: { for: "phone_number" } }, [
                            _vm._v("Phone Number"),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.user_data.mobile,
                                expression: "user_data.mobile",
                              },
                            ],
                            staticClass: "form-control",
                            class: _vm.$v.user_data.mobile.$error
                              ? "invalid-border"
                              : "",
                            attrs: {
                              id: "phone_number",
                              type: "text",
                              size: "15",
                              maxlength: "20",
                              placeholder: "Phone Number",
                            },
                            domProps: { value: _vm.user_data.mobile },
                            on: {
                              blur: function ($event) {
                                return _vm.$v.user_data.mobile.$touch()
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.user_data,
                                  "mobile",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          !_vm.$v.user_data.mobile.isNumber &&
                          _vm.$v.user_data.mobile.$error
                            ? _c("div", { staticClass: "custom-error-class" }, [
                                _vm._v(" Please enter only numbers "),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12 col-md-6" },
                        [
                          _c("label", { attrs: { for: "city" } }, [
                            _vm._v("City"),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.user_data.card_city,
                                expression: "user_data.card_city",
                              },
                            ],
                            staticClass: "form-control",
                            class: _vm.$v.user_data.card_city.$error
                              ? "invalid-border"
                              : "",
                            attrs: {
                              id: "city",
                              type: "text",
                              size: "60",
                              maxlength: "50",
                              placeholder: "City",
                            },
                            domProps: { value: _vm.user_data.card_city },
                            on: {
                              blur: function ($event) {
                                return _vm.$v.user_data.card_city.$touch()
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.user_data,
                                  "card_city",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm.$v.user_data.card_city.$error
                            ? _c("div", [
                                !_vm.$v.user_data.card_city.minLength
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [
                                        _vm._v(
                                          " Minimum 3 characters required. "
                                        ),
                                      ]
                                    )
                                  : !_vm.$v.user_data.card_city
                                      .isAllowedCharacters
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.specialCharacterErrMsg) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12 col-md-6" },
                        [
                          _c("label", { attrs: { for: "state" } }, [
                            _vm._v("State"),
                          ]),
                          _vm.user_data.country == "USA"
                            ? _c("span", { staticClass: "required_astric" }, [
                                _vm._v("*"),
                              ])
                            : _vm._e(),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.user_data.card_state,
                                expression: "user_data.card_state",
                              },
                            ],
                            staticClass: "form-control",
                            class: {
                              "invalid-border":
                                !_vm.$v.user_data.card_state
                                  .isAllowedCharacters,
                              "valid-border":
                                !_vm.$v.user_data.card_state.$error &&
                                _vm.$v.user_data.country.$model != "USA",
                              "mandatory-border":
                                _vm.$v.user_data.card_state.$error &&
                                _vm.$v.user_data.country.$model == "USA",
                            },
                            attrs: {
                              id: "state",
                              type: "text",
                              size: "60",
                              maxlength: "50",
                              placeholder: "State",
                            },
                            domProps: { value: _vm.user_data.card_state },
                            on: {
                              blur: function ($event) {
                                return _vm.$v.user_data.card_state.$touch()
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.user_data,
                                  "card_state",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm.$v.user_data.card_state.$error
                            ? _c("div", [
                                !_vm.$v.user_data.card_state.required &&
                                _vm.$v.user_data.country.$model == "USA"
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [_vm._v(" Complete required field ")]
                                    )
                                  : !_vm.$v.user_data.card_state
                                      .isAllowedCharacters
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.specialCharacterErrMsg) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12 col-md-6" },
                        [
                          _c("label", { attrs: { for: "zip_code" } }, [
                            _vm._v("Zip / Postal Code"),
                          ]),
                          _vm.user_data.country == "USA"
                            ? _c("span", { staticClass: "required_astric" }, [
                                _vm._v("*"),
                              ])
                            : _vm._e(),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.user_data.zipcode,
                                expression: "user_data.zipcode",
                                modifiers: { trim: true },
                              },
                            ],
                            staticClass: "form-control",
                            class: {
                              "invalid-border":
                                !_vm.$v.user_data.zipcode.isPostalCode,
                              "valid-border":
                                !_vm.$v.user_data.zipcode.$error &&
                                _vm.$v.user_data.country.$model != "USA",
                              "mandatory-border":
                                _vm.$v.user_data.card_state.$error &&
                                _vm.$v.user_data.country.$model == "USA",
                            },
                            attrs: {
                              id: "zip_code",
                              type: "text",
                              maxlength: "15",
                              placeholder: "Zip / Postal Code",
                            },
                            domProps: { value: _vm.user_data.zipcode },
                            on: {
                              blur: [
                                function ($event) {
                                  return _vm.$v.user_data.zipcode.$touch()
                                },
                                function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              ],
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.user_data,
                                  "zipcode",
                                  $event.target.value.trim()
                                )
                              },
                            },
                          }),
                          _vm.$v.user_data.zipcode.$error
                            ? _c("div", [
                                !_vm.$v.user_data.zipcode.required &&
                                _vm.$v.user_data.country.$model == "USA"
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [_vm._v(" Complete required field ")]
                                    )
                                  : !_vm.$v.user_data.zipcode.minLength
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [
                                        _vm._v(
                                          " Minimum 2 characters required. "
                                        ),
                                      ]
                                    )
                                  : !_vm.$v.user_data.zipcode.isPostalCode &&
                                    _vm.user_data.zipcode
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-error-class" },
                                      [
                                        _vm._v(
                                          " Valid Zip/Postal Code Required "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ]
              : _vm.currentSlider == 2
              ? [
                  _vm._m(4),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-md-6 col-sm-6 pl-0 xs-p-0" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 account-details" },
                        [
                          _c("div", { staticClass: "info" }, [
                            _vm._v("Provide Password Details:"),
                          ]),
                          _c(
                            "el-popover",
                            {
                              staticClass: "info-icon-class",
                              attrs: {
                                placement: "bottom-end",
                                trigger: "click",
                                "popper-class":
                                  "popup-background tootip-custom-small-width-class",
                              },
                              on: {
                                show: function ($event) {
                                  _vm.passwordInfoActive = true
                                },
                                hide: function ($event) {
                                  _vm.passwordInfoActive = false
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "content" }, [
                                _c("ul", { staticClass: "word-break" }, [
                                  _c("li", [
                                    _c("span", [
                                      _vm._v(
                                        "Please fill the mandatory details (if any) for all steps and they will be available with “"
                                      ),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "mandatory-sign" },
                                      [_vm._v("*")]
                                    ),
                                    _c("span", [_vm._v("” symbol.")]),
                                  ]),
                                  _c("li", [
                                    _vm._v("Have at least one capital letter"),
                                  ]),
                                  _c("li", [
                                    _vm._v("Have at least one number"),
                                  ]),
                                  _c("li", [
                                    _vm._v(
                                      "Have at least one special character !@#$.,+=( )_%^&*"
                                    ),
                                  ]),
                                  _c("li", [
                                    _vm._v("Be at least 10 characters"),
                                  ]),
                                ]),
                              ]),
                              !_vm.passwordInfoActive
                                ? _c("img", {
                                    staticClass: "info-img",
                                    attrs: {
                                      slot: "reference",
                                      src: "/static/images/icons/info_icon.svg",
                                      alt: "info-icon",
                                    },
                                    slot: "reference",
                                  })
                                : _vm._e(),
                              _vm.passwordInfoActive
                                ? _c("img", {
                                    staticClass: "info-img",
                                    attrs: {
                                      slot: "reference",
                                      src: "/static/images/icons/info_icon_active.svg",
                                      alt: "infoactive-icon",
                                    },
                                    slot: "reference",
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12 col-md-6" },
                        [
                          _c("label", { attrs: { for: "password" } }, [
                            _vm._v("Create Password"),
                          ]),
                          _c("span", { staticClass: "required_astric" }, [
                            _vm._v("*"),
                          ]),
                          _c("div", { staticClass: "password-flex" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.user_data.password,
                                  expression: "user_data.password",
                                },
                              ],
                              ref: "inputCreateTag",
                              staticClass: "form-control eye",
                              class:
                                _vm.submitStatus == "ERROR" &&
                                !_vm.user_data.password
                                  ? "invalid-border"
                                  : "",
                              attrs: {
                                id: "password",
                                type: "password",
                                maxlength: "65",
                                placeholder: "Create Password",
                                autocomplete: "new-password",
                              },
                              domProps: { value: _vm.user_data.password },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.user_data,
                                      "password",
                                      $event.target.value
                                    )
                                  },
                                  _vm.validate,
                                ],
                              },
                            }),
                            _vm.showCreatePassword
                              ? _c("img", {
                                  staticClass: "eye-icon",
                                  attrs: {
                                    src: "/static/images/icons/eye.svg",
                                    alt: "eye-icon",
                                  },
                                  on: { click: _vm.toggleCreatePassword },
                                })
                              : _vm._e(),
                            !_vm.showCreatePassword
                              ? _c("img", {
                                  staticClass: "eye-slash-icon",
                                  attrs: {
                                    src: "/static/images/icons/eye_slash.svg",
                                    alt: "eye-icon",
                                  },
                                  on: { click: _vm.toggleCreatePassword },
                                })
                              : _vm._e(),
                          ]),
                          _vm.submitStatus == "ERROR" && !_vm.user_data.password
                            ? _c("div", { staticClass: "custom-error-class" }, [
                                _vm._v(" Please enter a password "),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12 col-md-6" },
                        [
                          _c("label", { attrs: { for: "cpassword" } }, [
                            _vm._v("Confirm Password"),
                          ]),
                          _c("span", { staticClass: "required_astric" }, [
                            _vm._v("*"),
                          ]),
                          _c("div", { staticClass: "password-flex" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.user_data.cpassword,
                                  expression: "user_data.cpassword",
                                },
                              ],
                              ref: "inputConfirmTag",
                              staticClass: "form-control eye",
                              class:
                                (_vm.submitStatus == "ERROR" &&
                                  !_vm.user_data.cpassword) ||
                                _vm.user_data.password !=
                                  _vm.user_data.cpassword
                                  ? "invalid-border"
                                  : "",
                              attrs: {
                                id: "cpassword",
                                type: "password",
                                maxlength: "65",
                                placeholder: "Confirm Password",
                                value: "",
                              },
                              domProps: { value: _vm.user_data.cpassword },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.user_data,
                                    "cpassword",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm.showConfirmPassword
                              ? _c("img", {
                                  staticClass: "eye-icon",
                                  attrs: {
                                    src: "/static/images/icons/eye.svg",
                                    alt: "eye-icon",
                                  },
                                  on: { click: _vm.toggleConfirmPassword },
                                })
                              : _vm._e(),
                            !_vm.showConfirmPassword
                              ? _c("img", {
                                  staticClass: "eye-slash-icon",
                                  attrs: {
                                    src: "/static/images/icons/eye_slash.svg",
                                    alt: "eye-icon",
                                  },
                                  on: { click: _vm.toggleConfirmPassword },
                                })
                              : _vm._e(),
                          ]),
                          !_vm.user_data.cpassword &&
                          _vm.submitStatus == "ERROR"
                            ? _c("div", { staticClass: "custom-error-class" }, [
                                _vm._v(" Please confirm your password "),
                              ])
                            : _vm.user_data.cpassword &&
                              _vm.user_data.password != _vm.user_data.cpassword
                            ? _c("div", { staticClass: "custom-error-class" }, [
                                _vm._v(" Password does not match. "),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "col-xs-12 col-sm-offset-6 col-sm-6 footer pl-0 xs-p-0",
        },
        [
          _vm.currentSlider == 2
            ? _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "div",
                  {
                    staticClass: "d-flex",
                    class: !_vm.termsErr ? "mb-20" : "",
                  },
                  [
                    _c("span", { staticClass: "checkbox mr-12" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user_data.terms,
                              expression: "user_data.terms",
                            },
                          ],
                          attrs: {
                            type: "checkbox",
                            name: "terms",
                            id: "checkbox-register",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.user_data.terms)
                              ? _vm._i(_vm.user_data.terms, null) > -1
                              : _vm.user_data.terms,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = _vm.user_data.terms,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.user_data,
                                        "terms",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.user_data,
                                        "terms",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.user_data, "terms", $$c)
                                }
                              },
                              function ($event) {
                                return _vm.checkTerms()
                              },
                            ],
                          },
                        }),
                        _c("span", { staticClass: "cr" }),
                      ]),
                    ]),
                    _vm._m(5),
                  ]
                ),
                _vm.termsErr
                  ? _c(
                      "div",
                      { staticClass: "custom-error-class terms-err-class" },
                      [_vm._v(" " + _vm._s(_vm.termsErr) + " ")]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "col-xs-12 emergo-btns p-0 sm-pr-15 xs-p-0" },
            [
              _vm.currentSlider == 1 || _vm.currentSlider == 2
                ? _c("div", { staticClass: "col-sm-4 sm-pr-0 hidden-xs" }, [
                    _c(
                      "button",
                      {
                        staticClass: "mb-10 emergo-white-button btn-block",
                        on: { click: _vm.clearData },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "col-sm-4 sm-pr-0 visible-xs",
                  class: {
                    "col-sm-offset-8":
                      _vm.currentSlider !== 1 && _vm.currentSlider !== 2,
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "mb-10 xs-mb-30 emergo-green-button btn-block",
                      attrs: { disabled: _vm.submitStatus === "PENDING" },
                      on: {
                        click: function ($event) {
                          return _vm.submitDetails()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.currentSlider === 0 || _vm.currentSlider === 1
                              ? "Next"
                              : "Sign Up"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
              _vm.currentSlider == 1 || _vm.currentSlider == 2
                ? _c("div", { staticClass: "col-sm-4 sm-pr-0" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "mb-10 xs-mb-30 emergo-white-button btn-block",
                        class: { opacity: _vm.currentSlider === 0 },
                        attrs: { disabled: !_vm.currentSlider },
                        on: { click: _vm.changeSlider },
                      },
                      [_vm._v(" Back ")]
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "col-sm-4 sm-pr-0 hidden-xs",
                  class: {
                    "col-sm-offset-8":
                      _vm.currentSlider !== 1 && _vm.currentSlider !== 2,
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "mb-10 emergo-green-button btn-block",
                      attrs: { disabled: _vm.submitStatus === "PENDING" },
                      on: {
                        click: function ($event) {
                          return _vm.submitDetails()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.currentSlider === 0 || _vm.currentSlider === 1
                              ? "Next"
                              : "Sign Up"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
              _vm.currentSlider == 1 || _vm.currentSlider == 2
                ? _c("div", { staticClass: "col-sm-4 sm-pr-0 visible-xs" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "mb-10 xs-mb-30 mt-10 emergo-white-button btn-block",
                        on: { click: _vm.clearData },
                      },
                      [_vm._v(" Cancel ")]
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
      _c("verification-popup", {
        attrs: { successMessage: _vm.successMessage },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12 emergo-info" }, [
      _c("div", { staticClass: "emergo-img" }, [
        _c("img", {
          staticClass: "emergo-imge",
          attrs: {
            alt: "emergo-img",
            src: "/static/images/logos/emergo_logo.svg",
          },
        }),
      ]),
      _c("div", { staticClass: "active-account" }, [
        _c("span", [_vm._v("To activate your account,")]),
        _c("span", { staticClass: "fw-500" }, [_vm._v(" Contact Emergo ")]),
        _c("span", [
          _vm._v(
            " to enjoy selected premium services free of cost or contact your organization to be added as a team member to an existing account."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12 map-img" }, [
      _c("img", {
        staticClass: "rams-dashboard-logo",
        attrs: {
          src: "/static/images/logos/RAMS_Dashboard_Logo.png",
          alt: "rams-dashboard-logo",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12 map-img" }, [
      _c("img", {
        staticClass: "rams-dashboard-logo",
        attrs: {
          src: "/static/images/logos/RAMS_Dashboard_Logo.svg",
          alt: "rams-dashboard-logo",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12 pb-10 note-text" }, [
      _c("p", [_vm._v("Note: State and Zip Code is mandatory for US only.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12 map-img" }, [
      _c("img", {
        staticClass: "rams-dashboard-logo",
        attrs: {
          src: "/static/images/logos/RAMS_Dashboard_Logo.svg",
          alt: "rams-dashboard-logo",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "terms-conditions", attrs: { for: "terms" } },
      [
        _vm._v(" On behalf of my company, I agree to the "),
        _c(
          "a",
          { staticClass: "term-priv", attrs: { href: "/terms-of-service" } },
          [_vm._v("RAMS Software-as-a-Service Agreement")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }